import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 800px;
  max-width: 100%;
  margin: 0 auto;

  .level-wrapper {
    text-align: center;
    margin-bottom: 10px;
    margin: 0 auto;
    border-bottom: 1px solid #eee;
    padding-bottom: 22px;

    :first-child {
      padding-top: 22px;
    }
    .flex {
      display: flex;
      flex-flow: row wrap;
      justify-content: center;

      .link-wrapper {
        padding: 15px 75px;
        background-color: white;
        border: 1px solid #ddd;
        border-radius: 4px;
        margin-bottom: 4px;
        cursor: pointer;
        text-decoration: none;
        color: black;
        margin: 3px;
        flex: 0 1 15%;

        :hover {
          background-color: #dedede;
        }
      }
    }
  }

  @media (max-width: 400px) {
    margin-bottom: 40px;

    .level-wrapper {
      width: 100%;

      .flex {
        flex-direction: column;

        .link-wrapper {
          width: auto;
          max-width: 100%;
          padding: 15px 55px;
          margin: 4px 10px;
        }
      }
    }
  }
`;
